import { ReactNode } from "react";

import SearchInput from "components/SearchInput";
import { SEARCH_PLACEHOLDERS } from "constants/searchPlaceholders";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import LinkButton from "ds/components/Button/LinkButton";
import FiltersMobileTriggerButton from "components/Filters/MobileTriggerButton";
import Tooltip from "ds/components/Tooltip";
import DesktopView from "components/Mobile/DesktopView";
import useCanCreateModule from "shared/Module/access/useCanCreateModule";
import { AnalyticsPageModule } from "hooks/useAnalytics/pages/module";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import DocumentationIconButton from "components/DocumentationIconButton";
import { getDocsUrl } from "utils/getDocsUrl";

import { FILTERS_ORDER_SETTINGS_KEY } from "./constants";

type ModulesPageLayoutProps = {
  children?: ReactNode;
  hideActions?: boolean;
};

const ModulesPageLayout = ({ children }: ModulesPageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);
  const canCreateModule = useCanCreateModule();

  useTitle(`Modules · ${accountName}`);

  return (
    <>
      <ViewHeader firstLevel>
        <ViewHeaderWrapper>
          <ViewHeaderTitle>Module Registry</ViewHeaderTitle>
        </ViewHeaderWrapper>
        <ViewHeaderWrapper>
          <SearchInput
            placeholder={SEARCH_PLACEHOLDERS.MODULES}
            filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
          />
          <FiltersMobileTriggerButton />
          <DesktopView>
            <DocumentationIconButton
              href={getDocsUrl("/vendors/terraform/module-registry")}
              tooltipText="Go to modules documentation"
            />
            <Tooltip
              active={!!canCreateModule.message}
              on={(props) => (
                <LinkButton
                  {...props}
                  to="/new/module"
                  variant="primary"
                  disabled={!canCreateModule.result}
                  analyticsPage={AnalyticsPageModule.ModulesList}
                  analyticsTitle="Create Module"
                >
                  Create module
                </LinkButton>
              )}
            >
              {canCreateModule.message}
            </Tooltip>
          </DesktopView>
        </ViewHeaderWrapper>
      </ViewHeader>

      {children}
    </>
  );
};

export default ModulesPageLayout;
